import React, { memo } from 'react'

import { ScreenLoader } from './ScreenLoader'
import { useTranslation } from './services'

export const ExportScreenLoaderComponentName = 'ExportScreenLoader'

export const ExportScreenLoader = memo(({ ...rest }) => {
  const { t } = useTranslation()
  return (
    <ScreenLoader {...rest}>{t('defaultExportLoadingMessage')}</ScreenLoader>
  )
})
